import { keepPreviousData, queryOptions } from "@tanstack/react-query"
import { getStoresForSettingsFn } from "@/features/store-configuration/server/storeConfiguration"
import { storesQueryKeys } from "@/lib/queryKeys"
import type { StoresListFilters } from "../types/filters"

/**
 * Query configuration for stores list
 */
export const storesListQuery = (filters: StoresListFilters) =>
  queryOptions({
    queryKey: storesQueryKeys.list(filters),
    queryFn: () => getStoresForSettingsFn({ data: filters }),
    placeholderData: keepPreviousData,
  })
